document.addEventListener("DOMContentLoaded", function() {
    const countdownDateStr = "2025-07-31T23:30:00";
    const targetDate = new Date(countdownDateStr + "Z");

    const countdownFunction = setInterval(function() {
        const nowUTC = new Date();
        const distance = targetDate.getTime() - nowUTC.getTime();

        // Calcoli solo per ore, minuti e secondi
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Mostra solo H M S
        if (document.getElementById("countdown")) {
            document.getElementById("countdown").innerHTML =
                hours + "H " + minutes + "M " + seconds + "S";
        }
    }, 1000);
});
